export const capitalizeFirstLetter = (text: string): string => {
  const lowerCaseText = text.toLowerCase()
  const capitalizedText =
    lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1)
  return capitalizedText
}

export const capitalizeSentence = (sentence: string): string => {
  const words = sentence.split(' ')
  const capitalizedWords = words.map((word) => capitalizeFirstLetter(word))

  return capitalizedWords.join(' ')
}

// input 'Ana Maria Alvarenga Santos';
// Output: Ana M. A. S.
export const lastNamesAbbreviator = (
  fullName?: string | null
): string | null => {
  if (fullName && fullName.length > 1) {
    const names = fullName.split(' ')
    const firstName = names[0]
    let formattedName = capitalizeFirstLetter(firstName)

    for (let i = 1; i < names.length; i++) {
      const name = names[i]
      const initial = `${name.charAt(0).toUpperCase()}.`

      formattedName += ` ${initial}`
    }

    return formattedName
  }

  return fullName || null
}

// input 'Ana Maria Alvarenga Santos';
// Output: A. M. A. Santos
export const firstNamesAbbreviator = (
  fullName?: string | null
): string | null => {
  if (fullName && fullName.length > 1) {
    const names = fullName.split(' ')
    const lastName = names[names.length - 1]
    let formattedName = ''

    for (let i = 0; i < names.length - 1; i++) {
      const name = names[i]
      const initial = `${name.charAt(0).toUpperCase()}.`

      formattedName += `${initial} `
    }

    formattedName += `${capitalizeFirstLetter(lastName)}`

    return formattedName
  }

  return fullName || null
}

// input 'Ana Maria Alvarenga Santos';
// Output: Ana Santos
export const firstAndLastNames = (fullName?: string | null): string | null => {
  if (fullName && fullName.length > 1) {
    const names = fullName.trim().toLowerCase().split(' ')
    const firstName = names[0]
    const lastName = names[names.length - 1]

    return capitalizeSentence(`${firstName} ${lastName}`)
  }

  return null
}
